import { Switch } from '@/components/ui/switch';
import { useHourlyPackageMutations } from '../hooks/useHourlyPackages';
import type { BaseStatus } from '../types';

interface HourlyPackageStatusToggleProps {
  id: number;
  currentStatus: BaseStatus;
}

export function HourlyPackageStatusToggle({ id, currentStatus }: HourlyPackageStatusToggleProps) {
  const { changeStatusMutation } = useHourlyPackageMutations();
  const isActive = currentStatus === 'ACTIVE';

  return (
    <Switch
      checked={isActive}
      disabled={changeStatusMutation.isPending}
      onCheckedChange={(checked) => {
        changeStatusMutation.mutate({
          id,
          status: checked ? 'ACTIVE' : 'INACTIVE',
        });
      }}
    />
  );
}
